// external dependencies
import { unwrapResponseWithCode, ApiResponse } from "@swiggy-private/core-utils";
import { makeDownstreamApiCall, Response } from "@swiggy-private/checkout-core";

// internal-deps
import { JuspayClientAuthTokenData } from "@payment-client/interfaces/Juspay";

export const ENDPOINT = {
    GET_JUSPAY_CLIENT_AUTH_TOKEN: "/api/v3/juspay/get-client-auth-token",
};

export interface GetAuthTokenParams {
    apiHost: string;
    tenant: string;
}

export async function getPublicJuspayClientAuthToken(params: GetAuthTokenParams): Promise<JuspayClientAuthTokenData> {
    const { apiHost, tenant } = params;
    const response = unwrapResponseWithCode<JuspayClientAuthTokenData>(
        (await makeDownstreamApiCall<Response<JuspayClientAuthTokenData>>({
            apiHost,
            endpoint: ENDPOINT.GET_JUSPAY_CLIENT_AUTH_TOKEN,
            options: {
                headers: {
                    tenant,
                },
            },
        })) as ApiResponse<JuspayClientAuthTokenData>,
    );

    return response.toPromise();
}
